import { defineComponent } from 'vue';
export default defineComponent({
    name: 'CTopNotification',
    setup: function () {
        return {};
    }
});
